/* eslint-disable no-console */
const Lockr = require('lockr');

async function isLogged(){
    let token = Lockr.get('token');
    return token ? true : false;
}

export {
    isLogged
};